import { ICardDescriptionUnsavedState } from './types';
import { getCardDescriptionUnsavedLocalStorage } from './localStorage/actions/getCardDescriptionUnsavedLocalStorage';

const initialCardDescriptionUnsaved: ICardDescriptionUnsavedState = {};

export const getInitialCardDescriptionUnsaved = (): ICardDescriptionUnsavedState => {
    return {...initialCardDescriptionUnsaved, ...getCardDescriptionUnsavedLocalStorage()};
};
